/* Dynoforce productkop (sections/df-product.liquid).
   Uit de sectie gehaald op 21-10-2026 (Bouwer 4, expertbeoordeling) en
   geladen met defer. Wat Liquid levert staat op de wortel van de sectie
   ([data-df-pk]): data-mand-url, data-df-route (routeblok), data-df-pas
   (pasvorm), data-df-kr (kandidaten voor het kruimelpad); de plakbalk
   draagt data-form-id en data-sid. De taal komt uit <html lang>, die het
   thema op request.locale.iso_code zet. Volgorde zoals in de sectie:
   reviewlink, kruimelpad, plakbalk, koopblok. */
(function () {
  if (window.__dfPkJs) return;
  window.__dfPkJs = true;
  var TAAL = document.documentElement.getAttribute('lang') || '';

  /* Sterren bovenaan: naar de reviews. */
  (function(){
    var a = document.querySelector('[data-df-rv-link]'); if (!a) return;
    a.addEventListener('click', function(e){
      var doel = document.getElementById('reviews');
      if (!doel || doel.offsetParent === null) { doel = document.querySelector('.df-rv'); }
      if (doel) { e.preventDefault(); doel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  })();

  function initKr(sec) {
    if (!sec || sec.dataset.dfKrInit) return;
    sec.dataset.dfKrInit = '1';
    /* Dezelfde keuze als "Meer voor deze auto" (df-meercarbon, herstelronde
       16-10-2026): kent de pagina de auto van de bezoeker (de autokiezer in
       het menu bewaart hem in localStorage df_auto, met de url van de
       autocollectie) en is dat een van de kandidaten, dan noemen kruimelpad
       en regel boven de naam die auto. Zonder bekende auto, of bij een auto
       die niet bij dit deel hoort, blijft de keuze van Liquid staan. */
    /* 20-10-2026, laatste autokeuze wint: de gekozen auto volgens de regel
       in de header (window.DFKeuze), en opnieuw bij df:auto. Zonder auto
       komt de keuze van Liquid terug. */
    var kand;
    try { kand = JSON.parse(sec.getAttribute('data-df-kr') || '[]'); } catch (er) { return; }
    var a = sec.querySelector('[data-df-kr-link]');
    var e = sec.querySelector('[data-df-kr-naam]');
    var oud = { href: a ? a.getAttribute('href') : '', t: a ? a.textContent : '', n: e ? e.textContent : '' };
    function zet() {
      var auto = null;
      try {
        auto = window.DFKeuze ? window.DFKeuze.nu().auto : JSON.parse(localStorage.getItem('df_auto') || 'null');
      } catch (er) { auto = null; }
      var doel = null;
      if (auto && auto.url) {
        var h = String(auto.url).split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop();
        for (var i = 0; i < kand.length; i++) { if (kand[i].h === h) { doel = kand[i]; break; } }
      }
      if (doel && doel.nu) doel = null;
      if (a) { a.setAttribute('href', doel ? doel.u : oud.href); a.textContent = doel ? doel.t : oud.t; }
      if (e) e.textContent = doel ? doel.t : oud.n;
    }
    zet();
    document.addEventListener('df:auto', zet);
  }
  document.querySelectorAll('[data-df-pk][data-df-kr]').forEach(initKr);

  function initPlak(balk) {
    if (!balk || balk.dataset.dfPlakInit) return;
    balk.dataset.dfPlakInit = '1';
    var vorm = document.getElementById(balk.dataset.formId || '');
    var wortel = balk.dataset.sid ? document.querySelector('.df-pk-' + balk.dataset.sid) : null;
    if (!vorm) return;
    var koopregel = vorm.querySelector('.df-pk__koopregel') || vorm;
    var echteKnop = vorm.querySelector('.df-pk__koopknop');
    var echtePrijs = (wortel ? wortel.querySelector('[data-df-pk-prijs]') : null);
    var balkKnop = balk.querySelector('[data-df-pk-plakknop]');
    var balkPrijs = balk.querySelector('[data-df-pk-plakprijs]');
    if (!echteKnop || !balkKnop) return;
    /* Op de sectie luisteren en niet op het formulier: de variantkeuzes
       staan boven het formulier en niet erin, dus daar kwam de wissel nooit
       aan en bleef in de balk de prijs van de eerste variant staan (gemeten
       10-10-2026 op de Blu Eye 2: LCD-display 1.599 in het koopblok, 1.499
       in de balk). */
    var sectie = wortel || vorm;

    /* De balk spiegelt de echte knop, ook diens tekst: zo lopen montage-,
       uitverkocht- en aantalvarianten vanzelf mee met wat het koopblok al
       doet, zonder eigen kopie van die logica. */
    function spiegel() {
      var span = echteKnop.querySelector('span');
      var tekst = span ? span.textContent.trim() : '';
      if (tekst) balkKnop.textContent = tekst;
      balkKnop.disabled = echteKnop.disabled;
      if (!echtePrijs || !balkPrijs) return;
      /* Met het blok bezorgen, afhalen of monteren is de prijs in de balk
         het totaal van de gekozen tegel (K5, herstelronde 16-10-2026): de
         balk zei "€495,00 | In winkelmand met montage" terwijl blok en mand
         op €554 stonden. Toont de tegel geen bedrag (op afspraak), dan
         blijft het de stuksprijs. Het blok meldt elke herberekening met
         df:pk:knop, dus aantal, variant en montage lopen mee. */
      var tegel = sectie.querySelector('[data-df-pk-route]:not(.df-pk__route--uit) .df-pk__rt--aan [data-rt-tot]');
      var tot = tegel ? tegel.textContent.trim() : '';
      balkPrijs.textContent = /\d/.test(tot) ? tot : echtePrijs.textContent.trim();
    }
    spiegel();
    /* Na een variantwissel werkt het bestaande script prijs en knop bij;
       een tel later meelezen is genoeg. */

    /* Na een geslaagde toevoeging verdween de balk tot 10-10-2026 voor de
       rest van de paginaweergave, en daarmee de enige snelle weg naar de
       mand: de header plakt niet op een telefoon en de melding was niet te
       tikken. Nu slaat de balk om naar de mandstand: prijs en koopknop
       maken plaats voor de link "Bekijk winkelmand (n)" met het echte
       aantal uit /cart.js. De sectie meldt een geslaagde toevoeging met het
       event df:pk:toegevoegd (bij een fout komt dat niet), dus hier hoeft
       niets meer naar de spinner te kijken. Kiest de bezoeker daarna een
       andere variant of een ander aantal, dan is er iets nieuws te kopen en
       komt de koopstand terug. */
    var mandLink = balk.querySelector('[data-df-pk-plakmand]');
    var mandTeller = balk.querySelector('[data-df-pk-plakteller]');
    var mandstand = false;
    function zetStand(naarMand) {
      mandstand = !!(naarMand && mandLink);
      balkKnop.hidden = mandstand;
      if (balkPrijs) balkPrijs.hidden = mandstand;
      if (mandLink) mandLink.hidden = !mandstand;
    }
    document.addEventListener('df:pk:toegevoegd', function () {
      var mandUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      fetch(mandUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (mandTeller) mandTeller.textContent = (cart && typeof cart.item_count === 'number') ? ' (' + cart.item_count + ')' : '';
        })
        .catch(function () { if (mandTeller) mandTeller.textContent = ''; })
        .then(function () { zetStand(true); zet(); });
    });
    sectie.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-df-pk-optie], .df-pk__aantal')) zetStand(false);
      setTimeout(spiegel, 60);
    });
    /* De koopknop kan ook van tekst wisselen zonder change, bijvoorbeeld
       na een tik op een tegel van het routeblok (16-10-2026). De sectie
       meldt dat met df:pk:knop, zodat de balk nooit iets anders belooft
       dan de knop zelf. */
    sectie.addEventListener('df:pk:knop', spiegel);
    balkKnop.addEventListener('click', function () {
      spiegel();
      if (!echteKnop.disabled) echteKnop.click();
    });

    /* Tonen zodra de koopregel uit beeld is EN de bezoeker diep genoeg in de
       pagina zit; weg zodra een van beide niet meer geldt. De diepte-eis
       (instelling, standaard halverwege) voorkomt dat de balk al bij
       binnenkomst over de pagina hangt terwijl het koopblok een halve veeg
       verderop staat. De html-klasse laat de mobiele contactbalk wijken
       zolang wij er staan. */
    var drempel = Math.max(0, Math.min(90, parseInt(balk.dataset.plakVanaf || '50', 10) || 0)) / 100;
    var uitBeeld = false;
    var prijsregel = (wortel ? wortel.querySelector('.df-pk__prijs') : null);
    function diepGenoeg() {
      var baan = document.documentElement.scrollHeight - window.innerHeight;
      /* Bij een pagina korter dan het scherm valt er niets te scrollen en is
         de koopregel altijd in beeld, dus deze tak doet er dan niet toe. */
      return baan <= 0 || window.scrollY >= drempel * baan;
    }
    /* Niet over de prijs heen (10-10-2026). Sinds de kop op een telefoon
       compact is, staat de prijs bij binnenkomst onderin het scherm, precies
       waar de balk hangt: op een iPhone 13 lag de balk (586-652) over het
       grote prijsgetal (631-669), terwijl de koopknop zelf een duimveeg
       verderop stond. Zolang de prijsregel nog niet boven uit beeld is
       gescrold en de knop minder dan 400 px onder de onderrand zit (een
       duimveeg; op de Blu Eye 2 staat hij op 162 px), blijft de balk weg.
       Eerst gold dat alleen zolang de prijs zelf (deels) in beeld was en de
       knop binnen 200 px stond, maar op de Eventuri-intake valt de prijs
       door de lange naam net onder de vouw (675 bij een scherm van 664) en
       staat de knop op 266 px: de balk hing daar bij binnenkomst over de
       productnaam (nameting 10-10-2026). Staat de knop verder weg dan 400
       px, dan is de balk juist nodig en komt hij zoals voorheen. */
    function overDePrijs() {
      if (!prijsregel) return false;
      var pr = prijsregel.getBoundingClientRect();
      var kn = echteKnop.getBoundingClientRect();
      var h = window.innerHeight;
      return pr.bottom > 0 && kn.top < h + 400;
    }
    function zet() {
      var aan = uitBeeld && diepGenoeg() && !overDePrijs();
      balk.hidden = !aan;
      document.documentElement.classList.toggle('df-plak-aan', aan);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (lijst) {
        uitBeeld = !lijst[0].isIntersecting;
        zet();
      }, { rootMargin: '-72px 0px 0px 0px' }).observe(koopregel);
      /* De prijscontrole hangt aan de scrollstand, dus altijd meeluisteren;
         voorheen alleen bij een drempel boven nul. */
      window.addEventListener('scroll', zet, { passive: true });
    }
  }
  initPlak(document.querySelector('[data-df-pk-plak]'));

  (function () {
    function initDfPk(root) {
      if (!root || root.dataset.dfPkInit) return;
      root.dataset.dfPkInit = '1';

      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      var knop = root.querySelector('.df-pk__koopknop');
      var knopTekst = knop ? knop.querySelector('span') : null;
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var toastEl = root.querySelector('[data-df-pk-toast]');

      /* De fotostrook schuift zijwaarts. Alle maten liggen in CSS vast, dus er
         valt hier niets te meten; het script doet alleen de vervaging aan de
         rechterrand. */
      var kolEl = root.querySelector('.df-pk__gal .df-pk__thumbs');
      var railEl = root.querySelector('[data-df-pk-rail]');
      var pijlen = railEl ? Array.prototype.slice.call(railEl.querySelectorAll('[data-df-pk-pijl]')) : [];
      var meetTimer = null;

      /* De vervaging rechts hoort alleen te staan zolang er nog iets naast
         staat. Ben je aan het eind, dan is er niets meer te halen en zou een
         vage laatste foto alleen maar verwarren. Dezelfde meting stuurt de
         pijlen aan, dus die kunnen nooit uit de pas lopen met de vervaging. */
      function meerTonen() {
        if (!railEl || !kolEl) return;
        var meer = kolEl.scrollWidth - kolEl.clientWidth - kolEl.scrollLeft > 2;
        var minder = kolEl.scrollLeft > 2;
        if (meer) { railEl.setAttribute('data-meer', ''); }
        else { railEl.removeAttribute('data-meer'); }
        pijlen.forEach(function (p) {
          p.hidden = (p.dataset.dfPkPijl === '1') ? !meer : !minder;
        });
      }
      /* Een tik op een pijl schuift een schermbreedte op, iets minder dan
         helemaal, zodat de foto waar je was nog half in beeld blijft en je ziet
         waar je vandaan komt. */
      pijlen.forEach(function (p) {
        p.addEventListener('click', function () {
          var stap = Math.round(kolEl.clientWidth * 0.8) * (p.dataset.dfPkPijl === '1' ? 1 : -1);
          if (kolEl.scrollBy) { kolEl.scrollBy({ left: stap, behavior: 'smooth' }); }
          else { kolEl.scrollLeft += stap; }
        });
      });
      function meetStraks(ms) {
        window.clearTimeout(meetTimer);
        meetTimer = window.setTimeout(meerTonen, ms);
      }
      meerTonen();
      window.addEventListener('resize', function () { meetStraks(150); });
      window.addEventListener('load', meerTonen);
      if (kolEl) kolEl.addEventListener('scroll', meerTonen, { passive: true });

      /* Thumbs wisselen met het hoofdbeeld (beide kanten op). */
      var mainImg = root.querySelector('[data-df-pk-main] img');
      var fototel = root.querySelector('[data-df-pk-fototel]');
      function zetFototel() {
        if (!fototel || !mainImg) return;
        var n = root.querySelectorAll('[data-df-pk-thumb]').length + 1;
        var nr = parseInt(mainImg.dataset.nr || '0', 10) + 1;
        fototel.textContent = nr + ' / ' + n;
      }
      function wissel(t) {
        var ti = t.querySelector('img');
        if (!mainImg || !ti) return;
        var a = mainImg.dataset.groot || mainImg.getAttribute('src');
        var b = ti.dataset.groot || ti.getAttribute('src');
        var ma = mainImg.dataset.mega || '';
        var mb = ti.dataset.mega || '';
        var na = mainImg.dataset.nr || '';
        var nb = ti.dataset.nr || '';
        var altA = mainImg.getAttribute('alt');
        var altB = ti.getAttribute('alt');
        mainImg.dataset.groot = b; ti.dataset.groot = a;
        mainImg.dataset.mega = mb; ti.dataset.mega = ma;
        mainImg.dataset.nr = nb; ti.dataset.nr = na;
        mainImg.removeAttribute('srcset'); ti.removeAttribute('srcset');
        mainImg.setAttribute('src', b); ti.setAttribute('src', a);
        mainImg.setAttribute('alt', altB); ti.setAttribute('alt', altA);
        zetFototel();
      }
      root.querySelectorAll('[data-df-pk-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { wissel(t); });
      });

      /* Vegen over de hoofdfoto op een telefoon (10-10-2026). Wisselen kon
         alleen via de duimpjes van 69 px of de pijlen in de zoomweergave;
         een veeg over de foto deed niets. Een veeg naar links haalt de
         eerste foto uit de strook naar voren en zet de oude hoofdfoto
         achteraan, naar rechts andersom: de strook draait als een ring mee,
         zodat de eerstvolgende foto altijd vooraan in de strook staat en de
         zoomweergave (die de volgorde uit de HTML leest) dezelfde volgorde
         aanhoudt. Touch-events en geen pointer-events, zodat een muis op
         een groot scherm niets merkt. Niets wordt tegengehouden: verticaal
         scrollen over de foto blijft gewoon werken, en pas bij het loslaten
         wordt gekeken of het een zijwaartse veeg was (minstens 40 px, en
         duidelijk meer opzij dan omhoog of omlaag). */
      var hoofdVlak = root.querySelector('[data-df-pk-main]');
      if (hoofdVlak && mainImg && kolEl) {
        var veegX = 0, veegY = 0, veegAan = false, geveegd = false;
        hoofdVlak.addEventListener('touchstart', function (e) {
          veegAan = e.touches.length === 1;
          if (!veegAan) return;
          veegX = e.touches[0].clientX; veegY = e.touches[0].clientY;
        }, { passive: true });
        hoofdVlak.addEventListener('touchend', function (e) {
          if (!veegAan) return;
          veegAan = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dx = t.clientX - veegX, dy = t.clientY - veegY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          var thumbs = root.querySelectorAll('[data-df-pk-thumb]');
          if (!thumbs.length) return;
          var vooruit = dx < 0;
          var ruil = vooruit ? thumbs[0] : thumbs[thumbs.length - 1];
          wissel(ruil);
          if (vooruit) kolEl.appendChild(ruil); else kolEl.insertBefore(ruil, kolEl.firstChild);
          kolEl.scrollLeft = 0;
          meerTonen();
          mainImg.classList.remove('df-pk__veeg--l', 'df-pk__veeg--r');
          void mainImg.offsetWidth;
          mainImg.classList.add(vooruit ? 'df-pk__veeg--l' : 'df-pk__veeg--r');
          /* Een veeg mag de zoom niet openen; de browser stuurt na een
             echte veeg geen click, maar voor de zekerheid even dichthouden. */
          geveegd = true;
          window.setTimeout(function () { geveegd = false; }, 400);
        }, { passive: true });
        hoofdVlak.addEventListener('click', function (e) {
          if (geveegd) { e.preventDefault(); e.stopImmediatePropagation(); }
        }, true);
      }

      if (root.dataset.zoom !== 'nee') zetZoom(root);

      /* Bezorgopties: los of met montage, de keuze onder de knop op de
         templates zonder routeblok (de GO, dashcams). Met het routeblok (rt,
         hieronder) telt Monteren zonder montageproduct ook als zo'n keuze:
         dan gaat de knop naar de afspraakpagina. */
      var opts = root.querySelectorAll('[data-df-pk-opt]');
      var rt = null;
      function montageAan() {
        var m = root.querySelector('[data-df-pk-opt="montage"]');
        /* Met een ingebouwde variant voor dit display (P-5, 19-10-2026) is
           inbouwen een gewone bestelling en geen afspraakknop meer. */
        if (m && m.classList.contains('df-pk__opt--aan')) return !inbVariant();
        return !!(rt && rt.naarAfspraak());
      }
      function zetKnopTekst() {
        if (!knop || !knopTekst || knop.disabled) return;
        var rtLabel = rt ? rt.knopLabel() : null;
        knopTekst.textContent = rtLabel || (montageAan() ? knop.dataset.montageLabel : knop.dataset.koopLabel);
        /* De plakbalk spiegelt deze tekst; zie df:pk:knop daar. */
        try { root.dispatchEvent(new CustomEvent('df:pk:knop', { bubbles: true })); } catch (err) { /* oude browser */ }
      }
      opts.forEach(function (o) {
        var f = function () {
          opts.forEach(function (x) {
            var aan = x === o;
            x.classList.toggle('df-pk__opt--aan', aan);
            x.setAttribute('aria-pressed', aan ? 'true' : 'false');
          });
          if (inbLijst) foutWeg();
          inbTeken();
          zetKnopTekst();
        };
        o.addEventListener('click', f);
        o.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); f(); }
        });
      });
      if (knop) {
        knop.addEventListener('click', function (e) {
          if (!montageAan()) return;
          e.preventDefault();
          e.stopPropagation();
          var u = root.dataset.montageUrl || '/pages/afspraak?dienst=montage';
          var lijm = u.indexOf('?') > -1 ? '&' : '?';
          window.location.href = u + lijm + 'product=' + encodeURIComponent(root.dataset.productHandle || '');
        });
      }

      /* Variantkeuze: selects sturen prijs, voorraad, beeld en het id-veld. */
      var dataEl = root.querySelector('[data-df-pk-varianten]');
      var varianten = [];
      if (dataEl) { try { varianten = JSON.parse(dataEl.textContent); } catch (err) { varianten = []; } }
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-df-pk-optie]'));
      var prijsEl = root.querySelector('[data-df-pk-prijs]');
      var wasEl = root.querySelector('[data-df-pk-was]');
      var vrdEl = root.querySelector('[data-df-pk-vrd]');
      var vrdZin = root.querySelector('[data-df-pk-vrd-zin]');
      var tellerEl = root.querySelector('[data-df-lt-teller]');
      var afhEl = root.querySelector('[data-df-pk-afh]');
      var afhZin = root.querySelector('[data-df-pk-afh-zin]');
      function huidigeVariant() {
        var keuze = selects.map(function (s) { return s.value; });
        for (var i = 0; i < varianten.length; i++) {
          var v = varianten[i], klopt = true;
          for (var j = 0; j < v.opties.length; j++) {
            if (v.opties[j] !== keuze[j]) { klopt = false; break; }
          }
          if (klopt) return v;
        }
        return null;
      }
      function toonVariant(v) {
        var beschikbaar = !!(v && v.beschikbaar);
        if (idInput) {
          if (v) idInput.value = v.id;
          idInput.disabled = !beschikbaar;
        }
        if (prijsEl && v) prijsEl.textContent = prijsVan(v);
        if (wasEl) {
          if (v && v.was) { wasEl.textContent = v.was; wasEl.hidden = false; }
          else { wasEl.textContent = ''; wasEl.hidden = true; }
        }
        /* De levertijd is per variant vooraf uitgerekend in de sectie, zodat
           er hier niets herberekend hoeft te worden en de regel niet kan gaan
           afwijken van wat de server rendert. */
        if (vrdEl && vrdZin) {
          var zin = (v && v.ltzin) ? v.ltzin : (beschikbaar ? vrdZin.textContent : vrdEl.dataset.tekstUit);
          vrdZin.textContent = zin;
          var groen = !!(v && v.ltkleur === 'groen') && beschikbaar;
          vrdEl.classList.toggle('df-pk__vrd--uit', !groen);
        }
        if (tellerEl) {
          tellerEl.dataset.aan = (beschikbaar && v && v.ltteller === 'ja') ? 'ja' : 'nee';
          document.dispatchEvent(new CustomEvent('df:levertijd'));
        }
        if (afhEl && afhZin) {
          afhZin.textContent = (v && v.ltafhaal === 'ja') ? afhEl.dataset.voorraad : afhEl.dataset.besteld;
        }
        if (rt) rt.variant(v);
        inbTeken();
        if (knop && knopTekst) {
          knop.disabled = !beschikbaar;
          if (beschikbaar) zetKnopTekst();
          else knopTekst.textContent = knop.dataset.uitverkochtLabel || knop.dataset.koopLabel;
        }
        if (mainImg && v && v.beeld) {
          mainImg.dataset.groot = v.beeld;
          mainImg.removeAttribute('srcset');
          mainImg.setAttribute('src', v.beeld);
        }
        if (v && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState({}, '', u);
          } catch (err) { /* stil */ }
        }
      }
      selects.forEach(function (s) {
        s.addEventListener('change', function () { toonVariant(huidigeVariant()); });
      });

      /* Huisstijlbedrag (P-4/P-5, 19-10-2026): op pagina's met data-prijs-huis
         staat "€349,-" in plaats van "€349,00", net als in de tegels. */
      function prijsVan(v) {
        return (root.hasAttribute('data-prijs-huis') && v.prijshuis) ? v.prijshuis : v.prijs;
      }

      /* Versnellingsbak als tegels (P-4, bezoekerstest 19-10-2026). De
         tegels zijn echte radioknoppen; een keuze zet de waarde van het
         verborgen keuzemenu en meldt een change, zodat prijs, knop, id-veld
         en plakbalk de variant volgen zoals bij elk keuzemenu. Vooraf
         gekozen: de transmissie uit het kentekengeheugen (df_kenteken, v.
         transmissie "Automaat" of "Handgeschakeld"), en opnieuw na een
         kentekencheck op deze pagina (df:kenteken). Zonder gegevens blijft
         de eerste variant staan, Handgeschakeld. Staat er al een variant in
         de link (?variant=), dan gaat die bij het laden voor. */
      var tgGroep = root.querySelector('[data-df-pk-tegels]');
      if (tgGroep && selects.length) {
        var tgSel = selects[0];
        var tgLabels = Array.prototype.slice.call(tgGroep.querySelectorAll('.df-pk__tg'));
        var tgTeken = function () {
          tgLabels.forEach(function (l) {
            var i = l.querySelector('input');
            var aan = !!i && i.value === tgSel.value;
            l.classList.toggle('df-pk__tg--aan', aan);
            if (i) i.checked = aan;
          });
        };
        var tgZet = function (waarde) {
          if (tgSel.value === waarde) { tgTeken(); return; }
          tgSel.value = waarde;
          tgSel.dispatchEvent(new Event('change', { bubbles: true }));
        };
        tgGroep.addEventListener('change', function (e) {
          var i = e.target;
          if (!i || !i.classList || !i.classList.contains('df-pk__tgin')) return;
          tgZet(i.value);
        });
        tgSel.addEventListener('change', tgTeken);
        var bakUit = function (r) {
          var v = r && r.v;
          var t = (v && v.transmissie) ? String(v.transmissie).toLowerCase() : '';
          if (t.indexOf('auto') === 0) return 'automaat';
          if (t.indexOf('hand') === 0 || t.indexOf('manu') === 0) return 'handgeschakeld';
          return null;
        };
        var kiesBak = function (bak) {
          if (!bak) return;
          for (var k = 0; k < tgLabels.length; k++) {
            if (tgLabels[k].getAttribute('data-bak') === bak) {
              var i = tgLabels[k].querySelector('input');
              if (i) tgZet(i.value);
              return;
            }
          }
        };
        var bakUitGeheugen = function () {
          var r = null;
          try {
            /* 20-10-2026, laatste autokeuze wint: beide wegen volgen de regel. */
            r = (window.DFData && window.DFData.onthoudenKenteken)
              ? window.DFData.onthoudenKenteken()
              : (window.DFKeuze ? window.DFKeuze.nu().kenteken : JSON.parse(localStorage.getItem('df_kenteken') || 'null'));
          } catch (err) { r = null; }
          if (r && r.ts && Date.now() - r.ts > 30 * 24 * 60 * 60 * 1000) r = null;
          return bakUit(r);
        };
        var metVariant = false;
        try { metVariant = new URL(window.location.href).searchParams.has('variant'); } catch (err) { metVariant = false; }
        if (!metVariant) {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kiesBak(bakUitGeheugen()); });
          else kiesBak(bakUitGeheugen());
        }
        document.addEventListener('df:kenteken', function (e) { kiesBak(bakUit(e.detail)); });
      }

      /* Blu Eye 2 met inbouw bestellen (P-5, bezoekerstest 19-10-2026). Bij
         de tegel "Laten inbouwen in Elburg" en een display waarvoor het
         inbouwproduct een variant met dezelfde optiewaarde heeft: de prijs
         van die variant met "inclusief inbouw in Elburg" eronder, het
         datumveld en de knop "In winkelmand", die de ingebouwde variant
         toevoegt (zie het submit-script). Zonder zo'n variant blijft de oude
         afspraakknop. */
      var inbLijst = null;
      var inbJson = root.querySelector('[data-df-pk-inb]');
      if (inbJson) { try { inbLijst = JSON.parse(inbJson.textContent); } catch (err) { inbLijst = null; } }
      var inbBlok = root.querySelector('[data-df-pk-inbblok]');
      var inbDatum = root.querySelector('[data-df-pk-inbdatum]');
      var inbRegel = root.querySelector('[data-df-pk-inbregel]');
      var inbEigen = root.hasAttribute('data-df-pk-inbeigen');
      function inbVariant() {
        if (!inbLijst || !inbLijst.length) return null;
        var m = root.querySelector('[data-df-pk-opt="montage"]');
        if (!m || !m.classList.contains('df-pk__opt--aan')) return null;
        var v = huidigeVariant();
        if (!v || !v.opties) return null;
        var sleutel = v.opties.join('|');
        for (var i = 0; i < inbLijst.length; i++) {
          var iv = inbLijst[i];
          if (iv && iv.beschikbaar && iv.opties && iv.opties.join('|') === sleutel) return iv;
        }
        return null;
      }
      function foutWeg() {
        var w = root.querySelector('.product-form__error-message-wrapper');
        if (w) w.hidden = true;
      }
      if (inbDatum) inbDatum.addEventListener('input', foutWeg);
      function inbTeken() {
        if (!inbLijst) return;
        var iv = inbVariant();
        var aan = !!iv;
        if (aan) root.setAttribute('data-inbouw', '');
        else root.removeAttribute('data-inbouw');
        if (inbBlok) inbBlok.hidden = !aan;
        if (inbRegel) inbRegel.hidden = !aan;
        if (inbDatum) inbDatum.disabled = !aan;
        var v = huidigeVariant();
        if (prijsEl) {
          if (aan) prijsEl.textContent = iv.prijs;
          else if (v) prijsEl.textContent = prijsVan(v);
        }
        if (wasEl) {
          if (!aan && v && v.was) { wasEl.textContent = v.was; wasEl.hidden = false; }
          else { wasEl.textContent = ''; wasEl.hidden = true; }
        }
      }
      /* Niet eerder dan morgen; ook hier gezet, want de pagina kan uit de
         cache van gisteren komen. */
      if (inbDatum) {
        var mg = new Date();
        mg.setDate(mg.getDate() + 1);
        var tw = function (n) { return (n < 10 ? '0' : '') + n; };
        inbDatum.min = mg.getFullYear() + '-' + tw(mg.getMonth() + 1) + '-' + tw(mg.getDate());
      }
      if (inbLijst) {
        inbTeken();
        zetKnopTekst();
      }

      /* Bezorgen, afhalen of laten monteren (punt 2, 16-10-2026). Per keuze
         het totaal: prijs maal aantal plus verzending, plus niets, of plus
         montage. Sinds 17-10-2026 zonder Selleasy: de sectie zet het
         montageproduct uit de koppeling op het blok (data-mnt-cent en
         data-mnt-variant, zie montage_koppeling in de Liquid), zodat het
         bedrag er bij het laden al staat, en bij het toevoegen gaat de
         montageregel in dezelfde aanroep mee naar /cart/add.js (zie het
         submit-script onderaan). Zonder aanbod voor dit producttype is
         Monteren een afspraak: de knop gaat dan naar de afspraakpagina,
         zoals de oude montagekeuze ook deed.
         Alleen in de pagina als het blok aan staat (REG-8): op de andere
         productpagina's stond dit script voor niets. */
      if (root.hasAttribute('data-df-route')) {
      var rtEl = root.querySelector('[data-df-pk-route]');
      if (rtEl) {
        rt = maakRoute(rtEl);
        rt.start();
      }
      function maakRoute(el) {
        var T = {};
        try { T = JSON.parse((el.querySelector('[data-rt-tekst]') || {}).textContent || '{}'); } catch (err) { T = {}; }
        var d = el.dataset;
        var tegels = {};
        ['bezorgen', 'afhalen', 'montage'].forEach(function (k) { tegels[k] = el.querySelector('[data-rt="' + k + '"]'); });
        var uitleg = el.querySelector('[data-rt-uitleg]');
        var aantalEl = root.querySelector('.df-pk__aantal');
        var levEl = root.querySelector('[data-df-pk-levering]');
        var nu = {
          cent: parseInt(d.cent, 10) || 0, kort: d.kort || '', kleur: d.kleur || 'groen',
          elburg: d.elburg === 'ja', beschikbaar: d.beschikbaar !== 'nee', vartijd: d.vartijd || ''
        };
        var keuze = d.keuze || 'bezorgen';
        /* Het montageaanbod staat op het blok: een eigen montageproduct
           (bron eigen, met bedrag en variant) of niets, en dan is Monteren
           een afspraak. */
        var mnt = {
          bron: d.mntVariant ? 'eigen' : 'afspraak',
          cent: parseInt(d.mntCent, 10) || 0,
          variant: d.mntVariant || ''
        };
        /* Zelfde opmaak als het money-filter van de winkel; de placeholder
           tussen accolades wordt vervangen door het bedrag. */
        var plekhouder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
        function geld(cent) {
          var n = Math.round(cent);
          function maak(dec, dui, kom) {
            var s = (n / 100).toFixed(dec).split('.');
            s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, dui);
            return s.length > 1 ? s[0] + kom + s[1] : s[0];
          }
          return String(d.geld || '').replace(plekhouder, function (_, k) {
            if (k === 'amount') return maak(2, ',', '.');
            if (k === 'amount_no_decimals') return maak(0, ',', '.');
            if (k === 'amount_no_decimals_with_comma_separator') return maak(0, '.', ',');
            if (k === 'amount_with_apostrophe_separator') return maak(2, "'", '.');
            return maak(2, '.', ',');
          });
        }
        function vul(s, w) {
          return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return w[k] == null ? '' : w[k]; });
        }
        function aantal() {
          var n = aantalEl ? parseInt(aantalEl.value, 10) : 1;
          return n > 0 ? n : 1;
        }
        function verzending(basis) {
          var c;
          if (d.soort === 'xl') {
            c = parseInt(d.xl, 10) || 0;
            return { kan: true, cent: c, sub: vul(T.sub_xl, { geld: geld(c) }), uit: vul(T.uit_xl, { geld: geld(c) }) };
          }
          if (d.soort === 'nlbe') {
            var drempel = parseInt(d.gratis, 10) || 0;
            if (basis >= drempel) return { kan: true, cent: 0, sub: T.sub_gratis, uit: T.uit_gratis };
            c = parseInt(d.nlbe, 10) || 0;
            return { kan: true, cent: c, sub: vul(T.sub_verzend, { geld: geld(c) }), uit: vul(T.uit_verzend, { geld: geld(c), drempel: geld(drempel) }) };
          }
          if (d.soort === 'eu1' || d.soort === 'eu2') {
            c = parseInt(d[d.soort], 10) || 0;
            return { kan: true, cent: c, sub: vul(T.sub_verzend, { geld: geld(c) }), uit: vul(T.uit_eu, { geld: geld(c), land: d.landnaam || '' }) };
          }
          return { kan: false, cent: 0, sub: T.sub_niet, uit: T.uit_niet };
        }

        function zetTegel(k, tijd, tot, sub) {
          var t = tegels[k];
          if (!t) return;
          var a = t.querySelector('[data-rt-tijd]');
          var b = t.querySelector('[data-rt-tot]');
          var c = t.querySelector('[data-rt-sub]');
          if (a && a.textContent !== tijd) a.textContent = tijd;
          if (b && b.textContent !== tot) b.textContent = tot;
          if (c && c.textContent !== sub) c.textContent = sub;
        }
        function teken() {
          el.classList.toggle('df-pk__route--uit', !nu.beschikbaar);
          var n = aantal();
          var basis = nu.cent * n;
          var vz = verzending(basis);
          /* De variantnaam gaat voor (K9): "8-10 weken" uit "Zeevracht (8-10 weken)". */
          var kort = nu.vartijd ? nu.vartijd : ((nu.kleur !== 'groen' || !nu.kort) ? T.aanvraag : nu.kort);
          var tijdBez = nu.elburg ? T.klaar : kort;
          var tijdAfh = nu.elburg ? T.klaar : kort;
          var tijdMnt = nu.elburg ? T.afspraak : kort;
          zetTegel('bezorgen', vz.kan ? tijdBez : '—', vz.kan ? geld(basis + vz.cent) : '—', vz.sub);
          if (tegels.bezorgen) {
            tegels.bezorgen.classList.toggle('df-pk__rt--niet', !vz.kan);
            var ib = tegels.bezorgen.querySelector('input');
            if (ib) ib.disabled = !vz.kan;
          }
          if (!vz.kan && keuze === 'bezorgen') keuze = 'afhalen';
          zetTegel('afhalen', tijdAfh, geld(basis), T.sub_afhalen);
          /* De montage gaat per stuk mee in de mand (evenveel montageregels
             als onderdelen), dus ook haar bedrag telt maal het aantal. */
          if (mnt.bron === 'eigen') zetTegel('montage', tijdMnt, geld(basis + mnt.cent * n), vul(T.sub_montage, { geld: geld(mnt.cent * n) }));
          else zetTegel('montage', tijdMnt, T.afspraak, T.sub_montage_plek);
          Object.keys(tegels).forEach(function (k) {
            var t = tegels[k];
            if (!t) return;
            var aan = k === keuze;
            t.classList.toggle('df-pk__rt--aan', aan);
            var i = t.querySelector('input');
            if (i) i.checked = aan;
          });
          el.setAttribute('data-keuze', keuze);
          /* Afhalen gaat als regeleigenschap mee naar de mand (K4); bij
             bezorgen en monteren blijft het veld leeg en uit. */
          if (levEl) {
            var afh = keuze === 'afhalen';
            levEl.value = afh ? 'afhalen' : '';
            levEl.disabled = !afh;
          }
          var u;
          if (keuze === 'bezorgen') u = vz.uit;
          else if (keuze === 'afhalen') u = nu.elburg ? T.uit_afhalen_klaar : T.uit_afhalen;
          else u = mnt.bron === 'afspraak' ? T.uit_montage_afspraak : T.uit_montage;
          /* De levertijd staat sinds 17-10-2026 niet in elke tegel maar één
             keer hier, voor de gekozen route. */
          var tijdU = keuze === 'bezorgen' ? tijdBez : (keuze === 'afhalen' ? tijdAfh : tijdMnt);
          if (tijdU && tijdU !== '—') u = tijdU + ' · ' + u;
          if (uitleg && uitleg.textContent !== u) uitleg.textContent = u;
          /* De plakbalk neemt het totaal van de gekozen tegel over (K5), dus
             ook na een wissel van aantal of variant even melden. */
          try { root.dispatchEvent(new CustomEvent('df:pk:knop', { bubbles: true })); } catch (err) { /* oude browser */ }
        }

        el.addEventListener('change', function (e) {
          var i = e.target;
          if (!i || !i.classList || !i.classList.contains('df-pk__rtin')) return;
          keuze = i.value;
          teken();
          zetKnopTekst();
        });
        if (aantalEl) {
          aantalEl.addEventListener('input', teken);
          aantalEl.addEventListener('change', teken);
        }

        return {
          start: function () {
            teken();
            zetKnopTekst();
          },
          variant: function (v) {
            if (!v) {
              nu.beschikbaar = false;
            } else {
              nu.cent = typeof v.cent === 'number' ? v.cent : nu.cent;
              nu.kort = v.ltkort || '';
              nu.kleur = v.ltkleur || 'groen';
              nu.elburg = v.ltafhaal === 'ja';
              nu.vartijd = v.lttegel || '';
              nu.beschikbaar = !!v.beschikbaar;
            }
            teken();
          },
          naarAfspraak: function () {
            return keuze === 'montage' && mnt.bron === 'afspraak' && nu.beschikbaar;
          },
          knopLabel: function () {
            if (keuze !== 'montage' || !nu.beschikbaar) return null;
            return mnt.bron === 'afspraak' ? T.knop_afspraak : T.knop_montage;
          },
          /* Het montageproduct dat mee de mand in moet, of null: alleen bij
             de keuze Monteren met een eigen aanbod. */
          montage: function () {
            if (keuze !== 'montage' || mnt.bron !== 'eigen' || !nu.beschikbaar) return null;
            return { variant: mnt.variant, cent: mnt.cent, voor: d.mntVoor || '', soort: d.mntSoort || '' };
          }
        };
      }
      }

      if (root.hasAttribute('data-df-pas')) {
      /* Jouw auto naast de pasvorm (punt 1, 16-10-2026). Uit het onthouden
         kenteken (df-data.js, sleutel df_kenteken, dertig dagen); is dat er
         niet, uit de autokiezer in het menu (df_auto). Alleen merk, model en
         bouwjaar, nooit het kenteken zelf. Bewust geen oordeel of het past:
         het kentekenregister geeft de generatie niet altijd betrouwbaar door,
         dus de bezoeker vergelijkt zelf. Er wordt nooit iets opgevraagd.
         Sinds de herstelronde (K8) ook bij een antwoord zonder tuningcijfers
         (een EV, meerdere uitvoeringen, kan_wel): df-data.js bewaart dan
         naast v een lichte identiteit in auto. Alleen in de pagina als de
         pasvorm aan staat (REG-8). */
      /* 20-10-2026, laatste autokeuze wint (Luuk: kenteken van een Golf,
         daarna zelf een Tesla gekozen, en hier stond nog "Volkswagen Golf
         2013"). Kenteken en gekozen auto komen nu allebei uit de regel in de
         header (window.DFKeuze): het kenteken staat er alleen nog als er
         daarna geen andere auto is gekozen, en dan is het dezelfde auto. Op
         df:auto tekent de regel opnieuw, zonder herladen. */
      var jouw = root.querySelector('[data-df-pk-jouw]');
      function vulJouw() {
        if (!jouw) return;
        var tekst = '';
        var n = null;
        try { n = window.DFKeuze ? window.DFKeuze.nu() : null; } catch (err) { n = null; }
        var r = null;
        try {
          r = (window.DFData && window.DFData.onthoudenKenteken)
            ? window.DFData.onthoudenKenteken()
            : (n ? n.kenteken : JSON.parse(localStorage.getItem('df_kenteken') || 'null'));
        } catch (err) { r = null; }
        if (r && r.ts && Date.now() - r.ts > 30 * 24 * 60 * 60 * 1000) r = null;
        var v = r && (r.v || r.auto);
        if (v && (v.merk || v.model)) {
          tekst = [v.merk, v.model].filter(Boolean).join(' ');
          if (v.bouwjaar) tekst += ', ' + v.bouwjaar;
        } else {
          var a = null;
          if (n) a = n.auto;
          else { try { a = JSON.parse(localStorage.getItem('df_auto') || 'null'); } catch (err) { a = null; } }
          if (a && a.label) tekst = (a.merk ? a.merk + ' ' : '') + a.label;
        }
        var dd = jouw.querySelector('[data-df-pk-jouw-auto]');
        if (dd && tekst) {
          dd.textContent = tekst;
          jouw.hidden = false;
        } else {
          jouw.hidden = true;
        }
      }
      if (jouw) {
        /* df-data.js laadt met defer, dus pas na DOMContentLoaded is
           DFData er; zonder DFData lezen we localStorage zelf. */
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vulJouw);
        else vulJouw();
        document.addEventListener('df:kenteken', vulJouw);
        document.addEventListener('df:auto', vulJouw);
      }
      }

      /* Toevoegen: het product-form-element van het thema opent de drawer of
         notificatie. Ontbreekt dat element, dan hier via /cart/add.js met
         toast en tellerupdate; zonder JS post het formulier gewoon naar de cart. */
      /* De melding na het toevoegen is sinds 10-10-2026 een link naar de
         winkelmand die zes seconden blijft staan, of korter als je hem tikt.
         Daarvoor was het een tekst van 2,6 seconden zonder weg naar de mand,
         terwijl de header op een telefoon niet plakt en het mandicoon dus
         ver boven het scherm stond. Foutmeldingen blijven gewone tekst. */
      var toastTimer = null;
      var mandUrl = root.dataset.mandUrl || '/cart';
      function toast(tekst, naarMand) {
        if (!toastEl) return;
        window.clearTimeout(toastTimer);
        toastEl.textContent = '';
        if (naarMand) {
          var link = document.createElement('a');
          link.href = mandUrl;
          link.textContent = tekst;
          link.addEventListener('click', function () { toastEl.classList.remove('on'); });
          toastEl.appendChild(link);
        } else {
          toastEl.textContent = tekst;
        }
        toastEl.classList.add('on');
        toastTimer = window.setTimeout(function () { toastEl.classList.remove('on'); }, naarMand ? 6000 : 2600);
      }
      function toonFout(tekst) {
        var wrap = root.querySelector('.product-form__error-message-wrapper');
        var msg = root.querySelector('.product-form__error-message');
        if (!wrap || !msg) { toast(tekst); return; }
        msg.textContent = tekst;
        wrap.hidden = false;
      }
      /* De teller hoort bij de header en wordt daar bijgehouden; df-header.js
         zet daarvoor window.DFCart klaar. Hier zelf de tekst overschrijven
         ging mis: dan bleef het hidden-attribuut staan en zag je bij een
         eerste toevoeging in een lege mand helemaal niets veranderen. */
      function tellerBijwerken() {
        if (window.DFCart && typeof window.DFCart.ververs === 'function') {
          window.DFCart.ververs();
          return;
        }
        /* Header nog niet ingeladen: dan zelf ophalen, en wel inclusief het
           hidden-attribuut. */
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var n = cart.item_count;
            document.querySelectorAll('[data-df-cart-count]').forEach(function (el) {
              el.textContent = n > 99 ? '99+' : String(n);
              el.hidden = n === 0;
            });
          })
          .catch(function () { /* stil */ });
      }
      /* Het verzoek naar /cart/add.js en wat erna komt, gedeeld door de
         gewone toevoeging (het formulier) en die met montage (JSON met twee
         regels, hieronder). regelUit haalt de toegevoegde onderdeelregel uit
         het antwoord; komt er geen regel, dan is het een fout. */
      var enTaal = TAAL === 'en';
      var misTekst = enTaal ? 'Something went wrong, please try again' : 'Er ging iets mis, probeer het opnieuw';
      function voegToe(body, contentType, regelUit) {
        var spin = knop ? knop.querySelector('.loading__spinner') : null;
        if (spin) spin.classList.remove('hidden');
        if (knop) knop.setAttribute('aria-disabled', 'true');
        var headers = { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' };
        if (contentType) headers['Content-Type'] = contentType;
        fetch('/cart/add.js', { method: 'POST', body: body, headers: headers })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var regel = regelUit(res);
            if (regel) {
              toast(root.dataset.toastTekst || (enTaal ? 'Added. View your cart →' : 'Toegevoegd. Bekijk je winkelmand →'), true);
              tellerBijwerken();
              /* De plakkende koopbalk luistert hiernaar en slaat om naar
                 de mandstand. */
              document.dispatchEvent(new CustomEvent('df:pk:toegevoegd', { detail: regel }));
            } else {
              toonFout((res && (res.description || res.message)) || misTekst);
            }
          })
          .catch(function () { toonFout(misTekst); })
          .finally(function () {
            if (spin) spin.classList.add('hidden');
            if (knop) knop.removeAttribute('aria-disabled');
          });
      }
      if (form) {
        /* In de vangfase op de wortel (21-10-2026, Bouwer 4): dit script laadt
           nu met defer en staat dus niet meer vanzelf voor product-form.js.
           Zo komt onze afhandeling toch als eerste en houdt
           stopImmediatePropagation de handler van het thema tegen. */
        root.addEventListener('submit', function (e) {
          if (e.target !== form) return;
          if (montageAan()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var u = root.dataset.montageUrl || '/pages/afspraak?dienst=montage';
            var lijm = u.indexOf('?') > -1 ? '&' : '?';
            window.location.href = u + lijm + 'product=' + encodeURIComponent(root.dataset.productHandle || '');
            return;
          }
          /* Inbouw (P-5, 19-10-2026): de ingebouwde variant bij het gekozen
             display, of op de pagina van het inbouwproduct zelf de gewone
             variant, met de voorkeursdatum als regeleigenschap "Voorkeursdatum
             inbouw" (ISO-datum; sections/df-winkelmand toont hem leesbaar).
             Een lege datum gaat niet mee. */
          var ivk = inbVariant();
          if (ivk || (inbEigen && inbDatum)) {
            var datum = (inbDatum && !inbDatum.disabled) ? String(inbDatum.value || '') : '';
            if (datum && inbDatum.min && datum < inbDatum.min) {
              e.preventDefault();
              e.stopImmediatePropagation();
              toonFout(enTaal ? 'Choose a date from tomorrow onwards.' : 'Kies een datum vanaf morgen.');
              return;
            }
            if (ivk || datum) {
              e.preventDefault();
              e.stopImmediatePropagation();
              var foutWrap = root.querySelector('.product-form__error-message-wrapper');
              if (foutWrap) foutWrap.hidden = true;
              var fdi = new FormData(form);
              /* Een inbouwafspraak is altijd een (herstel 20-10-2026). */
              var regelInb = { id: ivk ? parseInt(ivk.id, 10) : parseInt(fdi.get('id'), 10), quantity: 1 };
              if (datum) regelInb.properties = { 'Voorkeursdatum inbouw': datum };
              voegToe(JSON.stringify({ items: [regelInb] }), 'application/json', function (res) {
                return (res && res.items && res.items.length) ? res.items[0] : null;
              });
              return;
            }
          }
          /* Monteren met een eigen montageproduct (17-10-2026): onderdeel en
             montage gaan in één aanroep naar /cart/add.js, als JSON met twee
             regels en hetzelfde aantal; zo komt er nooit een onderdeel zonder
             de gekozen montage in de mand. De montageregel krijgt de
             verborgen eigenschappen _montage_voor (product-id van het
             onderdeel) en _montage_soort (producttype); sections/df-winkelmand
             leest daaraan af bij welk onderdeel de montage hoort (geen
             koerier, het blijft in Elburg). Eigenschappen uit het formulier
             (zoals _levering) gaan mee op de onderdeelregel. */
          var mn = rt ? rt.montage() : null;
          if (mn && mn.variant) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var fdm = new FormData(form);
            var n = parseInt(fdm.get('quantity'), 10);
            if (!(n > 0)) n = 1;
            var deel = { id: parseInt(fdm.get('id'), 10), quantity: n };
            var eig = {};
            var eigN = 0;
            fdm.forEach(function (w, k) {
              var m = /^properties\[(.+)\]$/.exec(k);
              if (m) { eig[m[1]] = w; eigN++; }
            });
            if (eigN) deel.properties = eig;
            var items = [deel, { id: parseInt(mn.variant, 10), quantity: n, properties: { _montage_voor: mn.voor, _montage_soort: mn.soort } }];
            voegToe(JSON.stringify({ items: items }), 'application/json', function (res) {
              return (res && res.items && res.items.length) ? res.items[0] : null;
            });
            return;
          }
          /* Ignite's product-form stuurt na het toevoegen door naar /cart zodra
             er geen cart-notification of cart-drawer op de pagina staat:
             "else if (!this.cart) { window.location = routes.cart_url }". Die
             elementen staan hier niet, dus dan zou elke toevoeging een hele
             paginawissel worden en zag je de teller pas na het herladen.
             Staat er wel zo'n element, dan laten we het thema zijn werk doen.

             stopImmediatePropagation houdt Ignite's handler tegen, die op
             hetzelfde formulier zit. Onze listener staat er als eerste op:
             dit script staat inline in de sectie en product-form.js laadt met
             defer, dus die komt later. Zonder dat zou het product twee keer
             in de mand komen. */
          var lade = document.querySelector('cart-notification, cart-drawer');
          var pf = form.closest('product-form');
          if (pf && lade && window.customElements && customElements.get('product-form')) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          voegToe(new FormData(form), null, function (res) { return (res && res.id) ? res : null; });
        }, true);
      }
    }

    /* De zoomlaag bestaat een keer per pagina en hangt aan de body. In de
       sectie zetten zou hem breken: sectiewrappers krijgen een transform mee
       voor de scroll-animatie, en position:fixed rekent dan vanaf die sectie.
       Zelfde valkuil als bij de mobiele belbalk. */
    function zoomLaag() {
      if (window.__dfZoomLaag) return window.__dfZoomLaag;

      var laag = document.createElement('div');
      laag.className = 'df-zoom';
      laag.setAttribute('role', 'dialog');
      laag.setAttribute('aria-modal', 'true');
      var en = TAAL === 'en';
      laag.setAttribute('aria-label', en ? 'Photo enlarged' : 'Foto uitvergroot');
      laag.hidden = true;
      laag.innerHTML =
        '<div class="df-zoom__vlak"><img alt=""></div>' +
        '<button class="df-zoom__nav df-zoom__nav--vorige" type="button" aria-label="' + (en ? 'Previous photo' : 'Vorige foto') + '">&#8249;</button>' +
        '<button class="df-zoom__nav df-zoom__nav--volgende" type="button" aria-label="' + (en ? 'Next photo' : 'Volgende foto') + '">&#8250;</button>' +
        '<button class="df-zoom__knop" type="button" aria-label="' + (en ? 'Close' : 'Sluiten') + '">&#10005;</button>' +
        '<span class="df-zoom__tel"></span>';
      document.body.appendChild(laag);

      var beeld = laag.querySelector('img');
      var teller = laag.querySelector('.df-zoom__tel');
      var sluitKnop = laag.querySelector('.df-zoom__knop');
      var navs = laag.querySelectorAll('.df-zoom__nav');
      var lijst = [];
      var nu = 0;
      var terugNaar = null;

      function toon() {
        var b = lijst[nu];
        if (!b) return;
        laag.classList.remove('df-zoom--groot');
        beeld.setAttribute('src', b.src);
        beeld.setAttribute('alt', b.alt || '');
        teller.textContent = lijst.length > 1 ? (nu + 1) + (TAAL === 'en' ? ' of ' : ' van ') + lijst.length : '';
        navs.forEach(function (n) { n.hidden = lijst.length < 2; });
      }
      function ga(stap) {
        if (!lijst.length) return;
        nu = (nu + stap + lijst.length) % lijst.length;
        toon();
      }
      function sluit() {
        laag.hidden = true;
        laag.classList.remove('df-zoom--groot');
        beeld.removeAttribute('src');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', toets);
        if (terugNaar && terugNaar.focus) terugNaar.focus();
        terugNaar = null;
      }
      function toets(e) {
        if (e.key === 'Escape') { e.preventDefault(); sluit(); }
        else if (e.key === 'ArrowLeft') { ga(-1); }
        else if (e.key === 'ArrowRight') { ga(1); }
      }

      sluitKnop.addEventListener('click', sluit);
      laag.querySelector('.df-zoom__nav--vorige').addEventListener('click', function () { ga(-1); });
      laag.querySelector('.df-zoom__nav--volgende').addEventListener('click', function () { ga(1); });
      /* Naast de foto klikken sluit, op de foto klikken vergroot uit. */
      laag.addEventListener('click', function (e) {
        if (e.target === laag || (e.target.classList && e.target.classList.contains('df-zoom__vlak'))) sluit();
      });
      beeld.addEventListener('click', function () { laag.classList.toggle('df-zoom--groot'); });

      window.__dfZoomLaag = {
        open: function (beelden, index, vanaf) {
          if (!beelden.length) return;
          lijst = beelden;
          nu = Math.max(0, Math.min(index, beelden.length - 1));
          terugNaar = vanaf || null;
          laag.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', toets);
          toon();
          sluitKnop.focus();
        }
      };
      return window.__dfZoomLaag;
    }

    function zetZoom(root) {
      /* De lijst wordt bij elke klik opnieuw opgebouwd. Een klik op een thumb
         in de kolom wisselt het hoofdbeeld om, dus de volgorde ligt niet vast. */
      function beelden() {
        var els = [];
        var m = root.querySelector('[data-df-pk-main] img');
        if (m) els.push(m);
        root.querySelectorAll('[data-df-pk-thumb] img').forEach(function (i) { els.push(i); });
        return els;
      }
      function openBij(el) {
        var els = beelden();
        var i = els.indexOf(el);
        if (i < 0) i = 0;
        zoomLaag().open(els.map(function (x) {
          return {
            src: x.dataset.mega || x.dataset.groot || x.getAttribute('src'),
            alt: x.getAttribute('alt')
          };
        }), i, el.closest('button') || el);
      }

      var hoofd = root.querySelector('[data-df-pk-main]');
      if (hoofd && hoofd.querySelector('img')) {
        /* Pas hier een knop van maken, niet in de markup: zonder JavaScript is
           er niets om te openen en hoort er ook geen knop te staan. */
        hoofd.setAttribute('role', 'button');
        hoofd.setAttribute('tabindex', '0');
        hoofd.setAttribute('aria-label', TAAL === 'en' ? 'View this photo enlarged' : 'Bekijk deze foto uitvergroot');
        hoofd.addEventListener('click', function () { openBij(hoofd.querySelector('img')); });
        hoofd.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openBij(hoofd.querySelector('img')); }
        });
      }
      /* Een klik op een thumb wisselt het hoofdbeeld om; de zoom open je
         daarna met dat hoofdbeeld. Zo is er maar een manier en kan een klik
         niet twee dingen tegelijk betekenen. */
    }

    document.querySelectorAll('[data-df-pk]').forEach(initDfPk);
    if (!window.__dfPkGebonden) {
      window.__dfPkGebonden = true;
      document.addEventListener('shopify:section:load', function (e) {
        if (!e.target) return;
        e.target.querySelectorAll('[data-df-pk][data-df-kr]').forEach(initKr);
        initPlak(e.target.querySelector('[data-df-pk-plak]'));
        e.target.querySelectorAll('[data-df-pk]').forEach(initDfPk);
      });
    }
  })();
})();
